export const getWorkspaceMediaType = (fileType: string) => {
  if (fileType.includes('image')) return 'image'
  if (fileType.includes('video')) return 'video'
  return 'document'
}
